module.exports = __webpack_public_path__ + "014455cd9aa4cdeeb07d7267f8d24faa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg1.jpeg
// module id = 17
// module chunks = 0